import { API_URL } from "./apiConfig";

export const ScheduleInterview = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Interviews/ScheduleInterviewForCandidate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const UpdateInterview = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Interviews/UpdateInterviewForCandidate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const CancelInterview = async (newRequest) => {
  try {
    const response = await fetch(`${API_URL}Interviews/CancelInterviewForCandidate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newRequest),
    });
    if (response.ok) return await response.json();
    return { status: response.status };
  } catch (error) {
    console.error("API call failed:", error);
    throw error;
  }
};

export const loadcompetencies = async () => {
  try {
    const response = await fetch(`${API_URL}Interviews/GetCompetency`);
    if (!response.ok) throw new Error("Failed to fetch competencies");
    return await response.json();
  } catch (error) {
    console.error("Error fetching competencies:", error);
    return [];
  }
};
